import React, { useEffect } from 'react';

const ZapingWidgetClient = () => {
    useEffect(() => {
        // Create a div container
        const div = document.createElement('div');
        div.id = 'zaping-widget';
        div.style.position = 'fixed'; // Fix position
        div.style.bottom = '24px'; // Position 24px above the bottom
        div.style.right = '24px';  // Position 24px from the right
        div.style.zIndex = '99999999999'; // Set a very high z-index to ensure visibility
        div.style.backgroundColor = 'white'; // Optional: Add background color for visibility
        div.style.padding = '10px'; // Optional: Some padding for better look
        div.style.borderRadius = '8px'; // Optional: Rounded corners
        document.body.appendChild(div);
        
        // Dynamically create and append the script
        const script = document.createElement('script');
        script.src = 'https://zaping.io/dist/main.js';
        script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
        
        // Set the global variable and dispatch the event once the script is loaded
        script.onload = () => {
            window.ReactWidgetUserId = '65d4c2baa458de75b38c0ef4';
            window.dispatchEvent(new Event('ReactWidgetUserIdAvailable'));
        };

        // Clean up to avoid memory leaks when the component unmounts
        return () => {
            document.body.removeChild(div);
            document.body.removeChild(script);
        };
    }, []);

    return null; // This component doesn't render anything itself
};

export default ZapingWidgetClient;
